var map = {
	".": 45,
	"./": 45,
	"./Groupgg.png": 344,
	"./Icono 11.svg": 681,
	"./arrow-right.png": 345,
	"./check.svg": 346,
	"./error.svg": 347,
	"./happyface.svg": 348,
	"./icono1.svg": 349,
	"./icono2.svg": 682,
	"./icono2gris.svg": 683,
	"./icono3.svg": 684,
	"./icono3gris.svg": 685,
	"./icono4.svg": 686,
	"./icono4gris.svg": 687,
	"./index": 45,
	"./index.jsx": 45,
	"./ok.svg": 350,
	"./sadface.svg": 351
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 680;